export default "__VITE_ASSET__BjbOlsTu__"